export const iconFontAwesomeBuildingsHouseMedicalCircleExclamation = (
	<i className="fa-solid fa-house-medical-circle-exclamation"></i>
);
